import React, { createContext, useContext, useEffect, useState } from "react";
import client from "../api/client";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("cp_token");
    if (!token) {
      setLoading(false);
      return;
    }
    client
      .get("/api/auth/me")
      .then(({ data }) => setUser(data.user))
      .catch(() => localStorage.removeItem("cp_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await client.post("/api/auth/login", { email, password });
    localStorage.setItem("cp_token", data.token);
    setUser(data.user);
  };

  const register = async (payload) => {
    const { data } = await client.post("/api/auth/register", payload);
    localStorage.setItem("cp_token", data.token);
    setUser(data.user);
  };

  const logout = () => {
    localStorage.removeItem("cp_token");
    setUser(null);
  };

  const refreshUser = async () => {
    const { data } = await client.get("/api/auth/me");
    setUser(data.user);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
